import styled from '@emotion/styled'
import { Box, Flex } from 'theme-ui'

import media from '../../../common/MediaQueries'

const SectionContainerStyled = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  margin: 0;

  @media ${media.tablet} {
    flex-direction: row;
    margin: 0 5rem 0 4.125rem;
  }
`

const SectionMediaStyled = styled(Flex)`
  width: 100%;
  height: auto;
  margin-bottom: 2.75rem;

  @media ${media.tablet} {
    width: 42rem;

    height: 20.375rem;
    margin-top: 3.5625rem;
    margin-bottom: 0;
  }
`

const SectionContentStyled = styled(Flex)`
  flex-direction: column;
  width: 100%;

  @media ${media.tablet} {
    width: 36%;

    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-right: 4.375rem' : 'margin-left: 4.375rem')}
  }
`

const SectionNumberListStyled = styled(Flex)`
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 4.25rem;

  @media ${media.phone} {
    margin-bottom: 8rem;
  }

  @media ${media.tablet} {
    margin-bottom: 2.375rem;
  }
`

const SectionNumberListItemStyled = styled(Box)`
  display: flex;
  width: 50%;

  & > {
    margin: 0 auto;

    @media ${media.tablet} {
      margin: 0;
    }
  }

  @media ${media.maxTablet} {
    justify-content: center;
  }

  @media ${media.tablet} {
    width: 100%;
  }
  @media ${media.desktop} {
    width: 50%;
  }
`

const SectionDescStyled = styled(Box)`
  margin-bottom: 2.125rem;
  text-align: center;

  @media ${media.tablet} {
    margin-bottom: 3.625rem;
    ${({ theme }) => (theme.direction === 'rtl' ? 'text-align: right;' : 'text-align: left;')}
  }
`

const SectionBtnStyled = styled(Box)`
  display: flex;
  justify-content: center;

  @media ${media.tablet} {
    justify-content: flex-start;
  }
`

export {
  SectionContainerStyled,
  SectionMediaStyled,
  SectionContentStyled,
  SectionNumberListStyled,
  SectionDescStyled,
  SectionBtnStyled,
  SectionNumberListItemStyled
}
